<script setup lang="ts">
import { computed } from 'vue'
import Section from './Section.vue'
import { SectionSettings, Alignment, StatContent } from './types'
import { getColorById } from './utils'

interface Props {
  content?: StatContent[]
  settings: SectionSettings
}

const props = withDefaults(defineProps<Props>(), {
  settings: () => ({
    alignment: 'center',
    design_settings: {
      colors: [],
      fonts: [],
    },
  }),
  content: () => [],
})

const actualSettings = computed(() => {
  return {
    alignment: 'center' as Alignment,
    title: 'Industry leader in ROI',
    show_title: true,
    ...props.settings,
  }
})

const backgroundColor = computed(() =>
  getColorById(props.settings.design_settings?.colors, 'background_color'),
)

const textColor = computed(() => getColorById(props.settings.design_settings?.colors, 'text_color'))
</script>

<template>
  <Section :settings="actualSettings">
    <div class="stats-section">
      <div class="d-flex justify-content-center flex-wrap w-100">
        <UeTypography v-if="content?.length === 0" :contrast-with-color="backgroundColor">
          No stats added yet.
        </UeTypography>
        <div v-for="stat in content" :key="stat.id" class="col-12 col-md-4 mb-3">
          <div class="card h-100 bg-white" :style="{ color: textColor }">
            <div class="card-body">
              <h2 class="mb-3">{{ stat.headline }}</h2>
              <p class="sentence">{{ stat.sentence }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Section>
</template>

<style scoped lang="sass">
.stats-section
  margin-top: 2rem
.sentence
  font-weight: 600
</style>
